/**
 * This is a mapping of attribute codes to option labels.
 *
 * The reason (in this case) is to allow the client to have separate
 * attributes for groups (like colour) - and without this the FE
 * would show 'Colour Variations' or similar
 */
export const OPTION_LABELS = {
    colour_family: 'Colour',
};

/**
 * Any attribute codes that should be rendered as a swatch
 */
export const SWATCH_ATTRIBUTE_CODES = new Set(['colour_family', 'color']);

/**
 *
 */
export const SELECTORS = {
    MODAL: '[data-smooth-scroll="ModalStatic"]',
};
